import { useCallback, useEffect, useState } from 'react';

/**
 * Minimal data-fetching hook.
 *
 * Tracks a generation counter so a slow response from a previous dependency set
 * cannot overwrite a newer one — switching companies quickly would otherwise
 * paint one company's numbers under another's name, which on a cap table is
 * worse than a spinner.
 */
export function useAsync(fn, deps = []) {
  const [state, setState] = useState({ loading: true, data: null, error: null });
  const [generation, setGeneration] = useState(0);

  const reload = useCallback(() => setGeneration((g) => g + 1), []);

  useEffect(() => {
    let current = true;
    setState((s) => ({ ...s, loading: true, error: null }));

    Promise.resolve()
      .then(fn)
      .then((data) => {
        if (current) setState({ loading: false, data, error: null });
      })
      .catch((error) => {
        if (current) setState({ loading: false, data: null, error });
      });

    return () => {
      current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, generation]);

  return { ...state, reload };
}
